import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { ImageThumbnailComponent } from '@web/shared/ui';
import { finalize } from 'rxjs';
import { Guid, isNil, isNotNil, Nillable } from '@web/utils';
import { PublicBannerDataSourceService } from '../../services/public-banner-data-source.service';

@Component({
  selector: 'app-public-subscribe-page-header-banner-carousel-item',
  imports: [CommonModule, ImageThumbnailComponent, NgOptimizedImage],
  templateUrl:
    './public-subscribe-page-header-banner-carousel-item.component.html',
  styleUrl:
    './public-subscribe-page-header-banner-carousel-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicSubscribePageHeaderBannerCarouselItemComponent {
  private readonly bannerDataSource = inject(PublicBannerDataSourceService);

  public readonly bannerId = input.required<Guid>();
  public readonly imageSrc = input.required<string>();
  public readonly mobileImageSrc = input<Nillable<string>>();
  public readonly imageAlt = input.required<string>();
  public readonly externalLink = input<Nillable<string>>();

  protected readonly isNotNil = isNotNil;

  public handleLinkClick(event: MouseEvent): void {
    event.preventDefault();

    const externalLink = this.externalLink();

    if (isNil(externalLink)) {
      return;
    }

    this.bannerDataSource
      .registerRedirectById(this.bannerId())
      .pipe(finalize(() => window.open(externalLink, '_blank')))
      .subscribe();
  }
}
